<template>
  <div class="header--flow dea-border-grey-medium-light">
    <div class="header--flow__left">
      <LogosContainer v-for="(logo, key) in logos" :key="key" :index="key" :logo="logo" :sections="sections" />
      <!-- eslint-disable vue/no-html -->
      <div
        v-if="title"
        :class="`dea-${titleClass}`"
        class="header--flow__title dea-heading--medium__ml"
        v-html="title"
      ></div>
      <SectionArea v-else-if="Object.keys(sections).length !== 0" :sections="sections" />
      <!-- eslint-enable vue/no-html -->
    </div>
    <div class="header--flow__right">
      <slot name="userButton"></slot>
      <div class="header--flow__button-container">
        <Buttons class="dea-button--small dea-button--outline dea-button--no-border" @click="$emit('closed')">
          <div class="dea-ico-close"></div>
        </Buttons>
      </div>
    </div>
  </div>
</template>

<script>
import Buttons from "@/components/elements/Buttons";
import LogosContainer from "@/components/elements/LogosContainer";
import SectionArea from "@/components/elements/SectionArea";

export default {
  name: "HeaderFlow",
  components: { Buttons, LogosContainer, SectionArea },
  props: {
    logos: {
      type: Array,
      default: () => [],
    },
    sections: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      default: "",
    },
    titleClass: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

$deascuola-logo-height: 43px;

.header--flow {
  background-color: $dea-color-white;
  border-bottom: $border-light $dea-color-grey-light;
  display: flex;
  flex-direction: row;
  height: $space-x-large;
  justify-content: space-between;

  &__left,
  &__right {
    align-items: center;
    display: flex;
    flex-direction: row;
  }

  .logo--dea {
    &__desktop {
      width: auto;

      .header--center__logo-img {
        height: $deascuola-logo-height;
        width: auto;
      }
    }

    &__mobile {
      justify-content: center;

      .header--center__logo-img {
        height: auto;
        width: auto;
      }
    }
  }

  &__title {
    align-items: center;
    display: flex;
    font-size: $space-base;
    margin: 0 $space-base;

    @media screen and (max-width: $bp-size-small) {
      font-size: $space-small;
    }
  }

  &__button-container {
    align-items: center;
    border-left: $border-light $dea-color-grey-medium-light;
    display: flex;
    height: 80%;
  }

  .dea-button--no-border {
    border: 0;
    min-width: unset;

    &:active,
    &:focus,
    &:hover {
      box-shadow: none !important; // sass-lint:disable-line no-important
      outline-width: 0 !important; // sass-lint:disable-line no-important
    }

    .dea-ico-close {
      font-size: $dea-button-size-small;
    }
  }
}
</style>
